import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import store from '../store';
import {setMedia} from '../slices/statusSlice';

@customElement('dashboard-view')
export class DashboardView extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		flex-direction: row;
		height: 100%;
     	overflow-y: hidden;
	  }
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.status = state.status;
		this.dashboardActive = this.status.dashboardActive;
	}
	connectedCallback() {
		super.connectedCallback();
		addEventListener('keydown', this.handleKeydown);
	}
	handleKeydown = (e) => {
		switch (e.keyCode) {
			case 27: // ESC
				if (this.dashboardActive) {
					this.closeDashboard();
				}
				break;
		}
	};
	closeDashboard(e) {
		store.dispatch(setMedia({media: 'sections'}));
	}

	render() {
		return html`
				<feature-container></feature-container>
		`;
	}
}
